import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import classes from "./darkMode.module.css";
import PropTypes from "prop-types";
import { DarkModeContext } from "src/context/DarkModeContext";
import { useContext } from "react";

const getDesignTokens = (mode) => ({
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          transition: "all 0.4s ease-in-out",
          opacity: "0.9",
          "&:hover": {
            boxShadow: "4px 4px 2px rgba(100, 100, 100, 0.3)",
            borderRadius: "8px",
            opacity: "1",
          },
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          //...(mode !== "light" ? { color: "#353535" } : { color: "#D9D9D9" }),
          transition: "all 0.4s ease-in-out",
          "&:hover": { transition: "all 0.4s ease-in-out" },
        },
        outlined: {
          "&:hover": {
            boxShadow: "4px 4px 2px rgba(100, 100, 100, 0.25)",
            borderRadius: "8px",
          },
        },
        text: {
          "&:hover": {
            boxShadow: "0px 4px 2px rgba(100, 100, 100, 0.2)",
            borderRadius: "8px",
          },
        },
        contained: {
          ...(mode === "light"
            ? { /*lightMode */ backgroundColor: "#1f3a4d" }
            : { /*darkMode*/ backgroundColor: "#4D9093" }),
          borderRadius: "6px",
          "&:hover": {
            boxShadow: "4px 4px 2px rgba(100, 100, 100, 1)",
            borderRadius: "8px",
          },
        },
      },
    },
  },
  palette: {
    mode,
    appBar: {
      ...(mode === "light"
        ? {
            text: "#fff",
          }
        : {
            text: "#fff",
          }),
    },
    primary: {
      ...(mode === "light"
        ? {
            main: "#292929",
            contrastText: "#fff",
          }
        : {
            main: "#D9D9D9",
            contrastText: "rgba(0,0,0,0.87)",
          }),
    },
    primaryLight: {
      main: "#292929",
      contrastText: "#fff",
    },
    primaryDark: {
      main: "#D9D9D9",
      contrastText: "#fff",
    },
    secondary: {
      ...(mode === "light"
        ? {
            main: "#1f3a4d", // new: #1f3a4d
            contrastText: "#fff",
          }
        : {
            main: "#4D9093",
            contrastText: "rgba(0,0,0,0.87)",
          }),
    },
    info: {
      ...(mode === "light"
        ? {
            main: "#c4c4c4",
          }
        : {
            main: "#494949",
          }),
    },
    success: {
      ...(mode === "light"
        ? {
            main: "#2e7d32",
          }
        : {
            main: "#66bb6a",
          }),
    },
    warning: {
      ...(mode === "light"
        ? {
            main: "#ed6c02",
          }
        : {
            main: "#ffa726",
          }),
    },
    error: {
      ...(mode === "light"
        ? {
            main: "#ef5350",
          }
        : {
            main: "#f44336",
          }),
    },
    text: {
      ...(mode === "light"
        ? {
            primary: "rgba(0,0,0,0.87)",
            secondary: "rgba(0,0,0,0.7)",
            disabled: "rgba(0,0,0,0.48)",
          }
        : {
            primary: "#fff",
            secondary: "rgba(255,255,255,0.8)",
            disabled: "rgba(255,255,255,0.6)",
            icon: "rgba(255,255,255,0.22)",
          }),
    },
    background: {
      ...(mode === "light"
        ? {
            paper: "#efebe9",
            default: "ccc",
          }
        : {
            paper: "#1F1F1F",
            default: "#ddd",
          }),
    },
  },
  typography: {
    fontFamily: "Inter, Figtree, Lato, sans-serif",
    button: {
      textTransform: "none",
    },
  },
});
function DarkMode(props) {
  const { darkMode } = useContext(DarkModeContext) || {};
  const theme = createTheme(getDesignTokens(darkMode ? "dark" : "light"));

  return (
    <div>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className={darkMode ? classes.darkBgStyle : classes.lightBgStyle}>
          {props.children}
        </div>
      </ThemeProvider>
    </div>
  );
}

export default DarkMode;

DarkMode.propTypes = {
  children: PropTypes.node,
};
